import type { ModeloIzzaGPTModel } from "../models/modeloIzzaGPTModel"
import { ModeloIzzaGPTActionsTypes, type ModeloIzzaGPTActionModel } from "./modeloIzzaGPTActions"

const { CARREGAR, ATUALIZAR_MODELO } = ModeloIzzaGPTActionsTypes

export function modeloIzzaGPTReducer(
    state: ModeloIzzaGPTModel,
    action: ModeloIzzaGPTActionModel
): ModeloIzzaGPTModel {
    switch (action.type) {
        case CARREGAR:
            return { ...state, modelo: action.payload }
        case ATUALIZAR_MODELO:
            return { ...state, modelo: action.payload }
        default:
            return state
    }
}
